import { render, staticRenderFns } from "./logistics-tab.vue?vue&type=template&id=14981d62&scoped=true"
import script from "./logistics-tab.vue?vue&type=script&lang=js"
export * from "./logistics-tab.vue?vue&type=script&lang=js"
import style0 from "./logistics-tab.vue?vue&type=style&index=0&id=14981d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14981d62",
  null
  
)

export default component.exports